import React, { useState, MouseEvent } from 'react';
import styled from 'styled-components';

// 0 is middle C (C4) in our notation
// const chromaticScale = ['C', 'C#', 'D', 'Eb', 'E', 'F', 'F#', 'G', 'Ab', 'A', 'Bb', 'B'];
const noteNum = (i: number): number => ((i % 12) + 12) % 12;
// const noteOct = (i: number): number => Math.floor(i / 12) + 4;
const isBlackKey = (i: number): boolean => [1, 3, 6, 8, 10].includes(noteNum(i));

///const prettyPitch = (p) => `${chromaticScale[(p + 9) % 12]}, ${pitchFreq(p).toFixed(1)}Hz`;

const whiteKeyWidth = 20;
const keyXs = [0.0, 0.6, 1.0, 1.75, 2.0, 3.0, 3.6, 4.0, 4.7, 5.0, 5.75, 6.0];

export const Keyboard = (props) => {
    const { width, height, low, keyCount, playing, onChange } = props;
    const keyNums = Array.from({ length: keyCount }, (v, i) => low + i);
    const [active, setActive] = useState(false);

    const handleKey = (e: MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (! e.currentTarget.hasAttribute('data-key')) {
            setActive(false);
            onChange('stop');
        }
        const k = parseInt(e.currentTarget.getAttribute('data-key') || '0');
        if (onChange) {
            switch (e.type) {
                case 'mousedown':
                    if (active) {
                        onChange('note', k);              
                    } else {
                        setActive(true);
                        onChange('start', k);
                    }
                    break;
                case 'mouseenter':
                    active && onChange('note', k);
                    break;
                case 'mouseup':
                    setActive(false);
                    //onChange('stop');
                    break;
                default:
                    break;
            }
        }
    }

    const WhiteKeys = () => {
        const whites = keyNums.filter(i => !isBlackKey(i));
        return (<React.Fragment> {
            whites.map((kn, i) => (
                <WhiteKey
                    x={(Math.floor(i / 7) * 7.0 + keyXs[noteNum(kn)]) * whiteKeyWidth}
                    y={10}
                    key={i}
                    playing={playing === kn}
                    pointer-events="all"
                    data-key={kn}
                    onMouseDown={handleKey}
                    onMouseEnter={handleKey}
                    onMouseUp={handleKey} />
            )
            )
        }
        </React.Fragment>);
    };

    const BlackKeys = () => {
        const blacks = keyNums.filter(isBlackKey);
        return (<React.Fragment> {
            blacks.map((kn, i) => (
                <BlackKey
                    x={(Math.floor(i / 5) * 7.0 + keyXs[noteNum(kn)]) * whiteKeyWidth}
                    y={10}
                    key={i}
                    playing={playing === kn}
                    pointer-events="all"
                    data-key={kn}
                    onMouseDown={handleKey}
                    onMouseEnter={handleKey}
                    onMouseUp={handleKey} />
            )
            )
        }
        </React.Fragment>)
    }

    return (
        <Frame
            width={width}
            height={height} >
            <svg xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={height}
                viewBox={'' + [0, 0, width, height]} 
                onMouseDown={handleKey}>
                <WhiteKeys />
                <BlackKeys />
            </svg>
        </Frame>);
}

Keyboard.defaultProps = {
    width: 600,
    height: 200,
    low: -12,
    keyCount: 49
};

const Frame = styled.div`
    border: solid 1px gray;
    background-color: palegoldenrod;
`;

const WhiteKey = styled.rect`
    width: ${whiteKeyWidth}px;
    height: 80px;
    fill: ${props => (props.playing) ? '#e8e8e8' : 'white'};
    stroke: gray;
    :hover {fill: #f0f0f0;}
`;

const BlackKey = styled.rect`
    width: ${0.55 * whiteKeyWidth}px;
    height: 45px;
    fill: ${props => (props.playing) ? '#black' : '#606060'};
    stroke: black;
    :hover {fill: black}
`;